import React from 'react';
import styled from 'styled-components';
import { Button } from 'v3/components';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import LinkOutlinedIcon from '@mui/icons-material/LinkOutlined';

const ExternalLinkButton = styled(Button)`
  border: none !important;
  text-decoration: none;
  text-underline-offset: 3px;

  &:not(:disabled):hover {
    text-decoration: underline;
  }
`;

function renderPlateDisplay(label) {
  const text = String(label || '').trim();
  if (!text) return null;

  const parts = text.split(/\s*[|/]\s*/).filter(Boolean);

  return parts.map((part, index) => {
    const colonIndex = part.indexOf(':');
    if (colonIndex === -1) {
      return (
        <React.Fragment key={`${part}-${index}`}>
          {index > 0 && ' | '}
          <strong>{part.trim()}</strong>
        </React.Fragment>
      );
    }

    const prefix = part.slice(0, colonIndex + 1);
    const value = part.slice(colonIndex + 1).trim();

    return (
      <React.Fragment key={`${prefix}-${value}-${index}`}>
        {index > 0 && ' | '}
        <span>{prefix} </span>
        <strong>{value}</strong>
      </React.Fragment>
    );
  });
}

export default function PendingCard({
  item,
  styles,
  onAnswer,
  onCancel,
  onExternalLink,
  externalLinkLoading = false,
}) {
  const isAnnulled = item?.status === 'annulled';
  const externalLinkDisabled = isAnnulled || !!item?.isExpired;
  const hasAnnulledMeta =
    isAnnulled && (String(item?.annulledBy || '').trim() || String(item?.annulledAtLabel || '').trim());
  const annulledMetaLabel = hasAnnulledMeta
    ? `Anulado${item?.annulledBy ? ` por ${item.annulledBy}` : ''}${item?.annulledAtLabel && item.annulledAtLabel !== '—' ? ` em ${item.annulledAtLabel}` : ''
    }`
    : '';

  return (
    <div style={styles.itemCard('pending')}>
      <div style={styles.itemLeft}>
        <div style={styles.itemIcon('pending')}>
          <AssignmentOutlinedIcon style={{ fontSize: 18 }} />
        </div>

        <div style={styles.itemContent}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, width: '100%' }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: 8, flex: 1, minWidth: 0 }}>
              <div style={{ ...styles.itemTitle, minWidth: 0 }}>{`#${item.id} ${item.title}`}</div>
              {item.isRecurring && item.expirationDays && item.validUntilLabel ? (
                <span style={styles.recurringPill}>
                  Recorrente • Válido até {item.validUntilLabel}
                </span>
              ) : null}
              {isAnnulled ? (
                <span style={styles.annulledPill}>Anulado</span>
              ) : (
                <span style={styles.activePill}>Ativo</span>
              )}
            </div>

            <div style={{ marginLeft: 'auto', flexShrink: 0 }}>
              <Button
                onClick={() => onAnswer?.(item)}
                style={{ width: 'fit-content' }}
                disabled={isAnnulled}
              >
                <div style={styles.actionBtnInner}>
                  <WarningAmberIcon style={{ fontSize: 16 }} />
                  Responder Checklist
                </div>
              </Button>
            </div>
          </div>

          <div style={styles.metaRow}>
            {!!item.team && <span style={{ fontWeight: 700 }}>👥 {item.team}</span>}
          </div>
          {!!item?.plateDisplayLabel && (
            <div style={{ marginTop: 2, fontSize: 13, color: '#374151', fontWeight: 400 }}>
              {renderPlateDisplay(item.plateDisplayLabel)}
            </div>
          )}

          <div
            style={{
              marginTop: 8,
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              gap: 12,
              justifyContent: 'space-between',
              flexWrap: 'wrap',
            }}
          >
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ fontSize: 12, color: '#6B7280' }}>
                Solicitado por <strong>{item.requestedBy}</strong> em {item.requestedAt}
              </div>
              {hasAnnulledMeta ? (
                <div style={{ fontSize: 12, color: '#6B7280', marginTop: 4 }}>
                  {annulledMetaLabel}
                </div>
              ) : null}
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 30, flexWrap: 'wrap' }}>
              <ExternalLinkButton
                link
                onClick={() => onExternalLink?.(item)}
                style={{
                  width: 'fit-content',
                }}
                disabled={externalLinkDisabled}
                loading={externalLinkLoading}
              >
                <div style={styles.actionBtnInner}>
                  <LinkOutlinedIcon style={{ fontSize: 16 }} />
                  Link Externo
                </div>
              </ExternalLinkButton>
              <Button
                variant="secondary"
                onClick={() => onCancel?.(item)}
                style={{ width: 'fit-content' }}
                disabled={isAnnulled || externalLinkLoading}
              >
                <div style={styles.actionBtnInner}>
                  <BlockOutlinedIcon style={{ fontSize: 16 }} />
                  Anular checklist
                </div>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
